import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useRef, useState } from 'react';
export var useCheckOutOfBlock = function useCheckOutOfBlock(_ref) {
  var anchorRef = _ref.anchorRef,
      position = _ref.position,
      container = _ref.container,
      isHideWhenOutOfBlock = _ref.isHideWhenOutOfBlock;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOutOfBlock = _useState2[0],
      setIsOutOfBlock = _useState2[1];

  var initialParentRect = useRef(null);
  useEffect(function () {
    initialParentRect.current = container.parentNode.getBoundingClientRect();
  }, [container.parentNode]);
  useEffect(function () {
    var _anchorRef$current, _anchorRef$current$ge, _anchorRef$current$ge2;

    var anchorHeight = (anchorRef === null || anchorRef === void 0 ? void 0 : (_anchorRef$current = anchorRef.current) === null || _anchorRef$current === void 0 ? void 0 : (_anchorRef$current$ge = _anchorRef$current.getBoundingClientRect) === null || _anchorRef$current$ge === void 0 ? void 0 : (_anchorRef$current$ge2 = _anchorRef$current$ge.call(_anchorRef$current)) === null || _anchorRef$current$ge2 === void 0 ? void 0 : _anchorRef$current$ge2.height) || 0;

    var _getBoundingClientRec = container.parentNode.getBoundingClientRect(),
        top = _getBoundingClientRec.top,
        height = _getBoundingClientRec.height;

    var outOfBlock = isHideWhenOutOfBlock && !!position && initialParentRect.current && position.y + anchorHeight < initialParentRect.current.top;
    var outOfBottomBlock = initialParentRect.current && top + height > initialParentRect.current.bottom;
    setIsOutOfBlock(outOfBlock || !!outOfBottomBlock);
  }, [anchorRef, container.parentNode, isHideWhenOutOfBlock, position]);
  return {
    isOutOfBlock: isOutOfBlock
  };
};